$(function() {

    function select_country(slug){
        var url = '/de/winzer';
        if(slug){
            url += '/in/'+slug;
        }
        window.location.href = url;
    }

    $('select[name=producer_country]').on('change', function(){
        var slug = $(this).val();
        select_country(slug);
    });
});
